import type { BLOCK_VALUE_META } from 'App/Map/CurrentValuesMap/caches/BlockValuesCache/BlockValuesCache'
import type { OVERLAY_VALUE_META } from 'App/Map/CurrentValuesMap/caches/ImageOverlaysCache/ImageOverlaysCache'
import type { IRRIGATION_ZONE_VALUE_META } from 'App/Map/CurrentValuesMap/caches/IrrigationZoneValuesCache/IrrigationZoneValuesCache'
import type { STATION_META } from 'App/Map/CurrentValuesMap/caches/StationValuesCache/StationValuesCache'
import type { TRAP_META } from 'App/Map/CurrentValuesMap/caches/TrapValuesCache/TrapValuesCache'
import type { WIND_MACHINE_META } from 'App/Map/CurrentValuesMap/caches/WindMachineValuesCache/WindMachineValuesCache'
import { PersistentStoreName } from 'stores/_utils/persistentStore/persistenceStoresCleanUpMap'
import { persistentInit } from 'stores/_utils/persistentStore/persistentStore'

type TMapCardStoreState = {
  metaBlock?: BLOCK_VALUE_META
  metaIrrigationActivityZone?: IRRIGATION_ZONE_VALUE_META
  metaNdvi?: OVERLAY_VALUE_META
  metaStation?: STATION_META
  metaTrap?: TRAP_META
  metaWindMachine?: WIND_MACHINE_META
}

const keys: Record<keyof TMapCardStoreState, boolean> = {
  metaBlock: false,
  metaIrrigationActivityZone: false,
  metaNdvi: false,
  metaStation: false,
  metaTrap: false,
  metaWindMachine: false,
}

export const mapSelectedCardStore = {
  ...persistentInit<TMapCardStoreState>({
    initialState: {},
    keysToPutInURL: keys,
    keysToPutInPersistentStorage: keys,
    storeName: PersistentStoreName.MAP_SELECTED_CARD_STORE,
  }),
  actions: {
    hide: () => {
      mapSelectedCardStore.setState(() => ({}))
    },
    showBlock: (metaBlock: BLOCK_VALUE_META) => {
      mapSelectedCardStore.setState(() => ({ metaBlock }))
    },
    showIrrigationActivityZone: (metaIrrigationActivityZone: IRRIGATION_ZONE_VALUE_META) => {
      mapSelectedCardStore.setState(() => ({ metaIrrigationActivityZone }))
    },
    showNdvi: (metaNdvi: OVERLAY_VALUE_META) => {
      mapSelectedCardStore.setState(() => ({ metaNdvi }))
    },
    showStation: (metaStation: STATION_META) => {
      mapSelectedCardStore.setState(() => ({ metaStation }))
    },
    showTrap: (metaTrap: TRAP_META) => {
      mapSelectedCardStore.setState(() => ({ metaTrap }))
    },
    showWindMachine: (metaWindMachine: WIND_MACHINE_META) => {
      mapSelectedCardStore.setState(() => ({ metaWindMachine }))
    },
  },
}
